import styled from '@emotion/styled';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { EapAuthLayout } from 'src/shared/layout/EapAuthLayout';
import { Footer } from 'src/shared/layout/Footer';
import { color, font } from 'src/shared/styles/variables';

const HeadingText = styled.h2(
    {
        color: color.pickledBluewood,
    },
    font.black(30),
);

export const EmailConfirmationTokenExpiredPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <EapAuthLayout>
                <HeadingText>{t('user:email_confirmation.token_expired')}</HeadingText>
            </EapAuthLayout>
            <Footer />
        </>
    );
};
